import { useState } from "react";
import { motion } from "framer-motion";
import { SITE } from "@/data/site";

// Lazy, responsive image with fade-in + graceful fallback.
// fit: "cover" (default) or "contain" (full image visible, no crop)
export default function LazyImage({
  src,
  alt = "",
  className = "",
  imgClassName = "",
  fit = "cover",
  reveal = true,
  priority = false,
  ...rest
}) {
  const [loaded, setLoaded] = useState(false);
  const [errored, setErrored] = useState(false);
  const finalSrc = errored ? SITE.heroImage : src;
  const objectFit = fit === "contain" ? "object-contain" : "object-cover";

  return (
    <div className={`relative overflow-hidden ${fit === "contain" ? "bg-forest/5" : "bg-moss/10"} ${className}`} {...rest}>
      {!loaded && <div className="absolute inset-0 animate-pulse bg-moss/10" aria-hidden="true" />}
      <motion.img
        src={finalSrc}
        alt={alt}
        loading={priority ? "eager" : "lazy"}
        decoding="async"
        onLoad={() => setLoaded(true)}
        onError={() => setErrored(true)}
        className={`h-full w-full ${objectFit} ${imgClassName}`}
        initial={reveal ? { scale: 1.08, opacity: 0 } : false}
        animate={loaded ? { scale: 1, opacity: 1 } : {}}
        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
      />
    </div>
  );
}
